import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
export default new Vuex.Store({
  state: {
    socket: {
      isConnected: false,
      message: '',
      reconnectError: false
    },
    data: {},
    messages: [],
    lastMessage:[],
    open_room_id: null,
    open_room: {},
    test:'123'
  },
  mutations: {
    SOCKET_ONOPEN (state, event) {
      console.log(state)
      Vue.prototype.$socket = event.currentTarget
      state.socket.isConnected = true
      Vue.prototype.$socket.send(JSON.stringify({'action': 'login', 'user_id': Vue.prototype.$auth.user().id,'bearer':Vue.prototype.$auth.token()}))
    },
    SOCKET_ONCLOSE (state, event) {
      console.log(event)
      state.socket.isConnected = false
    },
    SOCKET_ONERROR (state, event) {
      console.error(state, event)
    },
    // default handler called for all methods
    SOCKET_ONMESSAGE (state, message) {
      state.socket.message = message
      var resp = JSON.parse(message.data)
      if (resp['type'] === 'clarify') {
        if(resp['val']==="+")
        {
          if(!Vue.prototype.$auth.user().noty[resp['target']])
          {
              Vue.prototype.$auth.user().noty[resp['target']]=1;
              return
          }
          else
          {
             Vue.prototype.$auth.user().noty[resp['target']]=Number(Vue.prototype.$auth.user().noty[resp['target']])+1 
             return
          }
        }
        if(resp['val']==='-')
        {
             Vue.prototype.$auth.user().noty[resp['target']]=Number(Vue.prototype.$auth.user().noty[resp['target']])-1 
             return
        }
        Vue.prototype.$auth.user().noty[resp['target']]=resp['val'];
        if(Vue.prototype.$auth.user().noty[resp['target']]==0)
        {
            Vue.prototype.$auth.user().noty[resp['target']]=null
        }
      }
      if (resp['type'] === 'noty') {
        
      }
      if (resp['type'] === 'chat') {
          state.lastMessage=resp
        if (Number(resp['room_id']) === Number(state.open_room_id)) {
          state.messages.push(resp)
          
        } else {
          Vue.prototype.$auth.user().noty['count_new_messages']++;
          Vue.prototype.$snotify.html('<div class="row" ><div class="col-4"><img width="100%" src="' + resp['user']['avatar'] + '" draggable="false"/></div><div class="col"><b>' + resp['user']['name'] + '</b><p style="font-size-12"><small>' + resp['data']['message'] + '</small></p></div></div>', {
            timeout: 2000,
            showProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            position: 'leftBottom'
          })
        }
        var audio = new Audio('https://scispace.hb.bizmrg.com/uploads/files/notify.ogg');
        audio.play();
        //$('#chatAudio')[0].play()
      }
    },
    // mutations for reconnect methods
    SOCKET_RECONNECT (state, count) {
      console.info(state, count)
    },
    SOCKET_RECONNECT_ERROR (state) {
      state.socket.reconnectError = true
    }
  },
  actions: {
    sendMessage: function (context, message) {
      Vue.prototype.$socket.send(message)
    }
  },
  getters: {
    message_count (state) {
      return state.message_count
    },
    data: (state) => {
        return state.data;
    },
  }
})
